export function createLookup<T, K extends keyof T, V>(
  items: T[],
  keyField: K,
  valMapper: (item: T) => V
): Record<string, V> {
  return items.reduce(
    (acc, item) => {
      acc[String(item[keyField])] = valMapper(item);

      return acc;
    },
    {} as Record<string, V>
  );
}
